import React from 'react';
import { Helmet } from 'react-helmet';
import ContactForm from './ContactForm';
import '../App.css';
import './Contact.css';

function Contact() {
  return (
    <div className="contact-page">
      <Helmet>
        <title>Contact — Erik Hoffman Photos</title>
        <meta
          name="description"
          content="Get in touch with Baltimore photographer Erik Hoffman to book a portrait, wedding, or travel shoot."
        />
      </Helmet>

      <h1 className="header-text">CONTACT</h1>

      <div className="contact-layout">
        {/* Left — contact details */}
        <div className="contact-info">
          <p className="contact-tagline">
            Let's work together. Whether it's a portrait session, your wedding day,
            or a creative project — I'd love to hear from you.
          </p>

          <div className="contact-detail">
            <i className="fas fa-envelope contact-icon" />
            <a href="mailto:erik@erikhoffmanphotos.com">erik@erikhoffmanphotos.com</a>
          </div>

          <div className="contact-detail">
            <i className="fas fa-map-marker-alt contact-icon" />
            <span>Baltimore, Maryland</span>
          </div>

          <div className="contact-social">
            <a
              href="https://instagram.com/erikhoffmanphotos"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-social-link"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram" /> @erikhoffmanphotos
            </a>
          </div>
        </div>

        {/* Right — form */}
        <div className="contact-form-container">
          <ContactForm />
        </div>
      </div>
    </div>
  );
}

export default Contact;
